import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { JobContentLinkKey } from '@doda/common/src/constants/jobSearchList/jobContent/jobContentLink';

/**
 * JobContentLinkのカテゴリに対応するイベント名を取得する
 * @param category - JobContentLinkのカテゴリ
 * @returns カテゴリに対応するイベント名、対応していない場合はnull
 */
export const getCategoryEventName = (
  category: JobContentLinkKey
): string | null => {
  switch (category) {
    case 'JobTrend':
      return 'jobtrend';
    case 'Occupation':
      return 'occupation';
    default:
      return null;
  }
};

/**
 * JobContentLinkのボタンクリックを計測する
 * @param category - JobContentLinkのカテゴリ
 */
export const measureLinkButtonClick = (category: JobContentLinkKey) => {
  const categoryEventName = getCategoryEventName(category);
  if (categoryEventName === null) {
    return;
  }
  tl(`Jobsearchlist_${categoryEventName}_click`, {});
};
